// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* hero skeleton */

.heroSkeleton {
  position: relative;
}

.heroSkeleton__imgContainer {
  height: 15rem;
  /* margin: 0 -13%; */
  position: relative;
}

.heroSkeleton__imgContainer::after {
  content: "";
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background: #14142b65;
}

.heroSkeleton.no-img img {
  display: none;
}

.heroSkeleton__imgContainer img {
  width: 100%;
  object-position: center 55%;
  height: inherit;
  object-fit: cover;
  /* object-position: 0 -15rem; */
}

.heroSkeleton__content {
  width: 80%;
  display: flex;
  align-items: flex-start;
  max-width: 1200px;
  flex-direction: column-reverse;
  justify-content: space-between;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.heroSkeleton__content > div:first-of-type {
  width: 100%;
  max-width: 40rem;
}

/* .heroSkeleton__content > div:first-of-type {
  display: flex;
} */

.heroSkeleton__location {
  display: flex;
  width: 100%;
  max-width: 20rem;
}

.heroSkeleton__date {
  max-width: 10rem;
  width: 100%;
  height: 5rem;
  display: none;
  margin-left: auto;
}

.heroSkeleton__text {
  height: 5rem;
}

@media (min-width: 375px) {
  .heroSkeleton__imgContainer {
    height: 12rem;
    /* margin: 0 -13%; */
    position: relative;
  }
}

@media (min-width: 500px) {
  .heroSkeleton__imgContainer {
    height: 15rem;
  }
}

@media (min-width: 768px) {
  .heroSkeleton {
    margin-top: -7.25rem;
    z-index: -1;
  }

  .heroSkeleton__imgContainer {
    height: 25rem;
    /* height: 20rem; */
    /* top: -10rem; */
  }

  .heroSkeleton__content {
    width: 80%;
    display: flex;
    align-items: flex-start;
    max-width: 1200px;
    /* flex-direction: row; */
    justify-content: space-between;
    margin: 0 auto;
    position: absolute;
    /* top: 75%; */
    top: 60%;
    left: 50%;
    transform: translate(-50%, -60%);
  }
}

@media (min-width: 992px) {
  .heroSkeleton__date {
    display: initial;
  }
  .heroSkeleton__content {
    align-items: center;
    flex-direction: row;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/HeroSkeleton/HeroSkeleton.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;EAC9B,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,aAAa;IACb,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,8BAA8B;IAC9B,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF","sourcesContent":["/* hero skeleton */\n\n.heroSkeleton {\n  position: relative;\n}\n\n.heroSkeleton__imgContainer {\n  height: 15rem;\n  /* margin: 0 -13%; */\n  position: relative;\n}\n\n.heroSkeleton__imgContainer::after {\n  content: \"\";\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background: #14142b65;\n}\n\n.heroSkeleton.no-img img {\n  display: none;\n}\n\n.heroSkeleton__imgContainer img {\n  width: 100%;\n  object-position: center 55%;\n  height: inherit;\n  object-fit: cover;\n  /* object-position: 0 -15rem; */\n}\n\n.heroSkeleton__content {\n  width: 80%;\n  display: flex;\n  align-items: flex-start;\n  max-width: 1200px;\n  flex-direction: column-reverse;\n  justify-content: space-between;\n  margin: 0 auto;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.heroSkeleton__content > div:first-of-type {\n  width: 100%;\n  max-width: 40rem;\n}\n\n/* .heroSkeleton__content > div:first-of-type {\n  display: flex;\n} */\n\n.heroSkeleton__location {\n  display: flex;\n  width: 100%;\n  max-width: 20rem;\n}\n\n.heroSkeleton__date {\n  max-width: 10rem;\n  width: 100%;\n  height: 5rem;\n  display: none;\n  margin-left: auto;\n}\n\n.heroSkeleton__text {\n  height: 5rem;\n}\n\n@media (min-width: 375px) {\n  .heroSkeleton__imgContainer {\n    height: 12rem;\n    /* margin: 0 -13%; */\n    position: relative;\n  }\n}\n\n@media (min-width: 500px) {\n  .heroSkeleton__imgContainer {\n    height: 15rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .heroSkeleton {\n    margin-top: -7.25rem;\n    z-index: -1;\n  }\n\n  .heroSkeleton__imgContainer {\n    height: 25rem;\n    /* height: 20rem; */\n    /* top: -10rem; */\n  }\n\n  .heroSkeleton__content {\n    width: 80%;\n    display: flex;\n    align-items: flex-start;\n    max-width: 1200px;\n    /* flex-direction: row; */\n    justify-content: space-between;\n    margin: 0 auto;\n    position: absolute;\n    /* top: 75%; */\n    top: 60%;\n    left: 50%;\n    transform: translate(-50%, -60%);\n  }\n}\n\n@media (min-width: 992px) {\n  .heroSkeleton__date {\n    display: initial;\n  }\n  .heroSkeleton__content {\n    align-items: center;\n    flex-direction: row;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
